<template>
	<div class="container">
		<p class="show-detail" @click='navigateTo("./balance-list")'>查看明细</p>
		<div class="logo"></div>
		<p class="text">我的余额</p>
		<p class="balance">
			<span class="unit">¥</span>
			<span class="money">{{walletData.balance}}</span>
		</p>
		<div class="submitBtn" @click='navigateTo("./recharge")'>充值</div>
	</div>	
</template>

<script>
	import CommonHeader from '@/components/CommonHeader'
	import { getMyWallet, getCardList } from '@/api/wallet'
	import { mapMutations, mapState } from 'vuex'

	export default {
		name: 'wallet',
		components: {
			CommonHeader,
		},
		data() {
			return {
				walletData:{}
			}
		},
        
        beforeCreate(){
        	sessionStorage.setItem("roleType","customer")
        },
		
		created(){
			this.getMyWallet()
		},
        
        mounted(){
            document.title = "我的钱包"
        },
		
		methods:{
			//获取余额列表
			async getMyWallet() {
			  const { data, status } = await getMyWallet();
			  console.log( data, '钱包数据')
			  if (status !== 200) return
			  this.walletData= data;
			},
			
			navigateTo(path){
				this.$router.push(path)
			}
		}
  
	}
</script>

<style lang="less" scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	.container {font-size:13px;height: 100vh;background:rgba(255,255,255,1);font-family:PingFangSC-Regular;font-weight:400;}
	.show-detail{margin-top: 20px;margin-right: 25px;padding-right:15px;background: url(../../assets/images/personal/ic_mine_enter.png) no-repeat right center;background-size: 6px;font-size: 13px;color:rgba(51,51,51,1);text-align: right}
	.logo{width: 80px;height: 80px;margin: 0 auto;margin-top:22px;background: url(../../assets/images/personal/pic_mine_money.png) no-repeat center center;background-size: cover}
	.text{color:rgba(51,51,51,1);font-size: 13px;margin-top: 16px;text-align:center}
	.balance{text-align:center}
	.unit{font-size:25px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(20,20,20,1);margin-right: 9px;display: inline-block;vertical-align: baseline;}
	.money{font-family:MicrosoftYaHeiSemibold;color:rgba(51,51,51,1);font-size: 50px;display: inline-block;vertical-align: middle;}
	.submitBtn{width:337.5px;height:46px;margin: 0 auto;margin-top: 27.5px;line-height: 46px;border-radius:2.5px;background:rgba(65,132,244,1);text-align: center;font-size: 18px;color:rgba(255,255,255,1);}
</style>